var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 962.7 599.2"
    },
    viewBox: "0 0 962.7 599.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#025b59}.st1{fill:teal}.st2{fill:#f99747}.st3{fill:#fb9390}.st4{fill:#ef7f7f}.st5{fill:#ef8080}.st6{fill:#0b0754}.st8{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m572 100 7-11c18-25 44-50 75-49-14-2-27 2-39 8-20 11-39 31-50 47l7 5z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m647 54 2-14-10-10c-2-1-1-3 1-3l14-3 6-13c1-1 3-2 4 0l6 13 15 1c1 1 2 3 1 4l-10 10 3 14c0 2-2 3-3 2l-13-6-13 7c-1 1-3 0-3-2z",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m367 28-2 7 6 5-3 7 8 4-3 8 7 4-1 9h-4l1-7-7-4 3-8-8-4 3-8-5-5 1-6-4-3 2-3z",
    className: "st1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207 464a22 22 0 1 1-33 30 22 22 0 0 1 33-30z",
    className: "st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184 490a12 12 0 1 0 18-16l-18 16z",
    className: "st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M770 590H237c-2 0-3 1-3 3 0 1 1 2 3 2h533l3-2c0-2-2-3-3-3z",
    className: "st0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m755 163-4 9-16-4-8 13-12-1-1 6 17 2 7-13 17 5 5-14zM195 273l-10 1-3-16h-15l-4-11-6 2 6 15h14l3 16 15-1zM663 159l6 2s10-4 11-6l2-7c2 0 4 1 5 4l-3 10 7 3c2 0 3 2 3 3v1c0 1 0 2-2 2l-1 1v2c1 1 0 3-2 3l-1 1v1c1 1 0 3-1 3l-1 1-2 3h-2l-16-5-4-3-6-3v-1l5-15h2zM287 178l-8-12c-19-28-49-56-83-55 16-2 31 2 44 10 22 12 44 34 55 52l-8 5z",
    className: "st2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m204 127-3-16 12-11c2-2 1-4-1-4l-16-3-7-14c0-2-3-2-4-1l-7 15-16 2c-2 0-3 2-1 4l11 11-3 16c-1 2 1 3 3 2l14-7 15 8c1 1 3 0 3-2z",
    className: "st2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m136 181 4-6-4-7 2-1 7 1 5-5 2 1v7l7 4v2l-7 3-1 7h-2l-5-5-7 1c-1 0-2-1-1-2zM828 283l-9-1-1 9-9-1-3 8-6 1v3l9-1 2-7h9l2-8 8 1zM347 81l-1-9h-8l-1-9-8-1-2-6-3 1 2 8 8 1 1 9 8 1v8zM152 347l7 2 5-5 7 4 4-8 9 4 4-6 9 2-1 3-6-1-5 6-8-3-4 7-8-4-6 5-6-2-3 4-2-2z",
    className: "st1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m562 61-1 5h-9l-1 8-7 2 1 3 9-2 1-7 9-1 1-8z",
    className: "st2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 724.1,
    cy: 80,
    r: 25.7,
    className: "st0",
    transform: "rotate(-20 724 80)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m742 83-11 3-4 11-2 1-6-10h-12l-1-2 7-9-3-11c-1-1 0-1 1-1l11 4 9-7c1-1 2 0 2 1l-1 11 10 7v2z",
    className: "st1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M815 194h6v-2l-3-5 1-6c1-1 0-2-1-1l-5 2-5-3h-1v7l-5 4v2l6 1 2 6 2 1 3-6z",
    className: "st2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M368 306s11-21 13-29l7-48c-1-3-10-9-9-11s10-2 12-2 6 1 8 3c2 1-2 47-3 57s-14 41-14 41l-14-11z",
    className: "st3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m388 218-2 1h-1s4 0 7 3l-4-4z",
    className: "st4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M592 226c2-1 3-4 3-6l1-3-17-3-1 3 4 24h11s-2-12-1-15z",
    className: "st3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M593 218s-3 1-5 4l-6-6c0-2 7 2 7 2h4z",
    className: "st5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M311 88h325v131H311z",
    className: "st0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M646 520s15 10 17 14c4 4-25 13-22 7l3-5c1-3-5-8-5-8l7-8z",
    className: "st3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m634 550 10-14s6-1 13-9l9 7s-7 8-17 16c0 0-6 5-15 8-8 3 0-8 0-8z",
    className: "st6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m767 256-4 6 4-8 1-3c1-2 0-3-2-1l-1 3-2 4-2 3v-1l2-6 2-4v-4l-2 4-2 3-3 5c-1-1 1-4 2-7v-6c-1-1-2 3-2 3l-1 3-2 3-5 8-2-2 1-3-1-2-2 3-1 4v8l-7 11v1l9 6 6-10 7-6c3-2 4-6 5-7l4-7c1-4-2-1-2-1z",
    style: {
      fill: "#fb9491"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m669 410-2 12-59 53 42 43-11 12s-63-46-65-52c-3-9 45-71 45-71l50 3z",
    className: "st0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M712 552s15 10 17 14c4 4-25 13-22 7l3-5c1-3-5-8-5-8l7-8z",
    className: "st3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m700 583 10-15s7-1 13-8c0 0 5 2 9 6 0 1-7 8-17 16 0 0-6 5-15 8-8 3 0-7 0-7z",
    className: "st6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m667 415 1 77 47 58-11 12c0 1-58-48-65-61-4-9-18-90-18-90l46 4z",
    className: "st1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M619 409c5-10 5-88 23-106l13 2 2 64c1 18 0 37 2 47 2 6-44 3-40-7z",
    className: "st8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M638 307s-8 22-14 19-41-39-41-41l-3-45 14-3 8 36s25 24 30 27c6 2 6 7 6 7z",
    className: "st2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M618 415c-5 0-6-1-9-2 0 0 3-43 12-89 3-18 4-25 11-24l10 3c-18 52-18 91-21 103l-3 9z",
    className: "st2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m644 295-2 8s0 7 3 7c4 1 10-5 10-5l3-22-14 12z",
    className: "st3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m644 295-2 8s0 7 3 7c4 1 10-5 10-5l3-22-14 12z",
    className: "st3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m658 283-14 12-1 6c5-1 12-7 15-18z",
    className: "st5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M644 263c-3 0-6 2-7 6l-3 11c-1 8 3 16 8 17 4 0 14-2 16-14 1-6 2-12-2-16-3-2-8-4-12-4z",
    className: "st3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M657 292s14-13 15-24c0-10-9-15-17-16l-10 1c-8 1-14 4-12 11 3 9 20 1 23 4 3 2-2 8 1 10s1 1 1 5l-1 9z",
    className: "st6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M662 280c0 2-2 4-3 4-2 0-3-2-2-5 0-2 2-4 3-4 2 0 3 2 2 5zM595 213c-2-2-4 1-2 4l-4 3s3 7 4 5c2-2 3-8 3-8l-1-4z",
    className: "st3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m751 284-10-10s-19 27-29 32-41 3-42 3l-15-4s-10 83 3 112c4 10 29 3 29 3l-8-39-2-39c1-1 36-9 45-16 10-8 29-42 29-42z",
    className: "st2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m386 223-1-3-5-1-3-2-1 1 1 2a169 169 0 0 0 11 8l2-3-4-2z",
    className: "st3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M275 360c17 18 32 2 31 2h7c11-1 20-8 24-18 15-2 26-16 21-29 7-8 5-22-2-30-1-15-20-17-32-12-7 3-12 8-15 15-13-1-23 8-26 21-19 5-26 32-8 51z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M386 534c-2 10-5 18-6 19l-2 3c1 12 9 19 16 24l-5-14 9-24c-5-1-7-4-12-8z",
    className: "st3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m364 393-41 28s20 13 27 20l44 37-12 60c4 4 12 8 17 9 11-24 23-73 22-79-2-8-57-75-57-75z",
    className: "st2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M260 449c2 2 10 17 13 25 4-2 7-6 12-8l-13-22c-1-8-3-9-3-9s-26 9-27 11c-2 3 13-1 18 3z",
    className: "st3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M273 446c2 0-1-10-1-12s-2-3-2-3a215 215 0 0 0-36 14c-2 5 21 6 25 4 3-2 5-4 14-3z",
    className: "st6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M372 402s-35-14-36-13c-3 12-14 8-21 29-3 8-5 31-7 47l-3 21s-8-12-23-29c-1-1-14 11-14 11 25 47 42 54 46 53 17-6 40-86 40-86l18-33z",
    className: "st2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m318 321-50-1h-42c-1 0-9-14-10-12-2 1 4 7 2 8s-21-2-21 0 12 2 12 3c0 2-12 0-13 2s12 1 12 2c1 1-11 3-10 5l10-1c0 2-7 5-6 6 1 2 6-3 10-3s7-3 14-1l50 6 40 3 2-17z",
    className: "st3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M379 358c1-7 0-20-1-22l8-24s-7-14-15-14c0 0-7 17-13 20l-3 1-29-1 2 28c8 20 7 39 5 45 0 4 34 14 39 11 0 0 6-31 7-44z",
    className: "st1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M336 319c-3-2-30-1-30-1s-3 18 0 23c0 0 23 3 22 5l8-27z",
    className: "st0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m341 306 3 14c1 4 7 17 15 15 9-2 0-14-2-18l-6-19-10 8z",
    className: "st3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m353 305-2-7-10 8 1 4c5 1 9-1 11-5z",
    className: "st4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M333 277s-4 3-6 8c-1 6 1 20 12 23 12 4 17-8 15-16-3-9-8-20-21-15z",
    className: "st3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M355 288c0 3-1 4-3 4l-2-4c0-3 2-4 3-4l2 4z",
    className: "st3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M380 554c0-2-8 4-10 5s-2 3-2 3c0 1 19 25 25 28h2c3-1-2-20-6-24-3-3-5-4-9-12z",
    className: "st6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M335 277s-2 15-7 18-3 10-3 10-5-16-1-21 11-7 11-7z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M331 298v5c-1 1-4 0-5-2v-5c1-1 3 0 5 2z",
    className: "st3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m392 168-5-1-4-2-3-3 3-2 2 3 3 1 4 1 4-1 3-2 1-3-1-3-3-2-4-1-6-1-4-3-2-4 2-5 4-3a14 14 0 0 1 14 2l3 3-3 1-2-2-3-2h-3l-4 1-3 2-1 3 1 3 3 1 4 1 5 2 4 3 2 4-2 5-4 3-5 1zM420 168a11 11 0 0 1-11-7l-1-7v-18h3v18l1 6 3 3 5 2 5-2 3-3 1-6v-18h3v18l-1 6-2 4a11 11 0 0 1-9 4zM452 168l-6-1-5-4-4-5-1-6 1-7 4-5 5-3 6-2 6 2 6 5-3 1a12 12 0 0 0-21 4l-1 5 1 5 3 4 4 2 4 1 6-1 4-3 3 1-6 5-6 2zM483 168l-6-1-5-4-3-5-1-6 1-7 3-5 5-3 6-2 7 2 5 5-3 1a12 12 0 0 0-20 4l-1 5 1 5 2 4 4 2 5 1 5-1 4-3 3 1-5 5-7 2zM500 167v-31h19v3h-16v10h13v3h-13v12h16v3h-19zM535 168l-5-1-4-2-2-3 2-2 2 3 3 1 4 1 4-1 3-2 1-3-1-3-3-2-4-1-6-1-4-3-1-4 1-5 4-3 6-1a15 15 0 0 1 9 3l2 3-3 1-2-2-3-2h-3l-4 1-3 2-1 3 1 3 3 1 4 1 5 2 4 3 2 4c0 2 0 4-2 5l-4 3-5 1zM562 168l-5-1-4-2-2-3 2-2 2 3 3 1 4 1 4-1 3-2 1-3-1-3-3-2-4-1-6-1-4-3-1-4 1-5 4-3 6-1a15 15 0 0 1 9 3l2 3-3 1-2-2-3-2h-3l-4 1-3 2-1 3 1 3 3 1 4 1 5 2 4 3 2 4c0 2 0 4-2 5l-4 3-5 1z",
    className: "st8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess01);
export default __webpack_public_path__ + "static/media/success-01.2365faf8885f2d98090069636fef4474.svg";
export { ForwardRef as ReactComponent };